// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tD3h","importantInfo":"styles_importantInfo__3QJ0R"};